import { createApp } from "vue";

import Grid from "~/vue/Grid.vue";

// Main app
const grid = async () => {
	const app = createApp(Grid);
	return app.mount("#grid");
};

// Execute async function
grid().then(() => {
	console.log();
});
